<template>
    <div id="bene-aud-bt-suburb-container">
        <f7-list form class="form-group" v-if="showFormSet.kaasiDetails">
            <f7-list-input
                input-id     ="suburb"
                name         ="suburb"
                type         ="text"

                :label       ="$t('beneficiary-suburb')"
                :placeholder ="$t('beneficiary-suburb')"
                :value       ="city"

                outline
                autocomplete ="off"
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.checkSuburbList();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'city',
                'cityId',
                'cityList',
            ])
        },
        on: {
            pageBeforeRemove() {
                const self = this;
                // Destroy all autocompletes
                self.autocompleteSuburbDropdownSimple.destroy();
            },
        },
        methods: {
            ...mapActions('beneficiary', [
                'setCity',
                'setIsSuburbSelected'
            ]),

            checkSuburbList(){
                if(this.cityList.length > 0){
                    const self         = this;
                    const app          = self.$f7;
                    const cList        = self.cityList;

                    // Simple Dropdown
                    self.autocompleteSuburbDropdownSimple = app.autocomplete.create({
                        inputEl: '#suburb',
                        openIn : 'dropdown',
                        class  : '',
                        closeOnSelect: true,
                        preloader: true, //enable preloader
                        source : function(query, render) {
                            //console.log("query: "+query+" ("+query.length+")")
                            //console.log("value : "+self.city)
                            //console.log("value on typing : "+ self.Dom7("#suburb").val())
                            //console.log("curr cList : ", cList)
                            let results = [];
                            if(query.length <= 1) { // Need to enter min 2 chars
                                //console.log("results : ", results)
                                //console.log("cList : ", cList)

                                if(self.Dom7("#suburb").val().trim() == ""){
                                    self.autocompleteSuburbDropdownSimple.close();
                                    cList.map((item) => {
                                        results.push(item.value);
                                        return
                                    });
                                }else{

                                    //self.autocompleteSuburbDropdownSimple.open();
                                    cList.map((item) => {
                                        if(item.value.toString().toLowerCase().indexOf(self.city.toLowerCase()) >= 0) {
                                            results.push(item.value);
                                        }
                                    });
                                }


                                //render(results);
                                return;
                            }else{
                                self.autocompleteSuburbDropdownSimple.open();
                            }

                            //console.log("cList Suburb: ", cList)

                            // Find Matched Items
                            cList.map((item) => {
                                if(item.value.toString().toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                    results.push(item.value);
                                }
                            });

                            // Render Items By Passing Array With Result Items
                            render(results.sort());
                        },
                        on      :{
                            change: function(value){
                            /*
                            let selectedSuburbId = 0;
                            let selectedSuburb = "";

                            cList.map((item) => {
                                if(item.value.toString().toLowerCase() == value) {
                                    selectedSuburbId = item.key;
                                    selectedSuburb = item.value;
                                }
                            });

                            self.setCity({id: selectedSuburbId, name: selectedSuburb})
                            */

                            self.setIsSuburbSelected(true);
                            self.changeCity(value);
                            self.validateInput(document.getElementById('suburb'));
                            self.setInput("suburb");
                            }
                        }
                    })
                }
            },

            changeCity(id){
                this.$emit("changeCity", id);
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>